// Number formats from the design (state/marketing.tsx).
export const inr = (n) => `₹${Math.round(n).toLocaleString("en-IN")}`;
export const compact = (n) => (n >= 100_000 ? `${(n / 100_000).toFixed(1)} L` : n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n));

/** Shown where the design has a number but the backend has no data for it yet. */
export const NO_DATA = "—";

/** YYYY-MM-DD in local time (what the backend's date filters expect). */
export const ymd = (ms) => {
  const d = new Date(ms);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const DAY = 86_400_000;

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
/** "27 Oct" (design: state/crm.tsx fmtShort). */
export const fmtShort = (ts) => {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

/** "27 Oct 2026" (design: fmtDate). */
export const fmtDate = (ts) => {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

/** "2 h ago", "Yesterday", "3 days ago", else the date (design: fmtAgo). */
export function fmtAgo(ts, now = Date.now(), withYear = false) {
  const today = new Date(now).setHours(0, 0, 0, 0);
  const m = Math.round((now - ts) / 60_000);
  if (m < 1) return "Just now";
  if (m < 60) return `${m} min ago`;
  if (m < 60 * 24 && ts >= today) return `${Math.floor(m / 60)} h ago`;
  if (ts >= today - DAY) return "Yesterday";
  const d = Math.floor((today - ts) / DAY) + 1;
  if (d < 7) return `${d} days ago`;
  return withYear ? fmtDate(ts) : fmtShort(ts);
}

/** Local midnight of the day `ms` falls on. */
export const dayStart = (ms) => new Date(ms).setHours(0, 0, 0, 0);
